import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { RaceSummaryRowMarketsConfigType } from 'src/domains/sportsbook/webview/components/raceSummary/templates/rowMarkets/summaryMarkets/RaceSummaryRowMarkets';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';
import { RaceSummaryRowMarkets } from './templates/rowMarkets/summaryMarkets/RaceSummaryRowMarkets';
import { RaceSummarySubRacesState } from 'src/domains/sportsbook/webview/components/raceSummary/RaceSummarySubRaces.state';
import { RowMarketsState } from 'src/domains/sportsbook/webview/components/raceSummary/templates/rowMarkets/summaryMarkets/RaceSummaryRowMarkets.state';

const viewConfig: RaceSummaryRowMarketsConfigType = {
    displayShowMoreButton: false,
    withTableHeader: true,
};

interface RaceSummarySubRacesPropsType {
    eventId: EventId;
}

export const RaceSummarySubRaces = observer('RaceSummarySubRaces', (props: RaceSummarySubRacesPropsType) => {
    const [state] = useState(() => new RowMarketsState(new RaceSummarySubRacesState(props.eventId)));

    return (
        <RaceSummaryRowMarkets
            state={state}
            eventId={props.eventId}
            config={viewConfig}
        />
    );
});
